import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Token_NULL_getInstance2d65is50ce53 as Token_NULL_getInstance } from './json/JsonReader.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Present1shu3953j96zb as Present,
  Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance,
  Optional8wzzg0qzssox as Optional,
} from './Optional.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Companion_instance31iaet2guytyg as Companion_instance } from './json/MapJsonReader.mjs';
import { ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException } from '../exception/Exceptions.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from './json/MapJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from './json/JsonWriters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { readAny17j2jqaxubdko as readAny } from './json/JsonReaders.mjs';
import { Upload1b180qcf3cx10 as Upload } from './Upload.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_StringAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return StringAdapter;
}
var StringAdapter;
function get_IntAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return IntAdapter;
}
var IntAdapter;
function get_DoubleAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return DoubleAdapter;
}
var DoubleAdapter;
function get_FloatAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return FloatAdapter;
}
var FloatAdapter;
function get_LongAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return LongAdapter;
}
var LongAdapter;
function get_BooleanAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return BooleanAdapter;
}
var BooleanAdapter;
function get_AnyAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return AnyAdapter;
}
var AnyAdapter;
function get_UploadAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return UploadAdapter;
}
var UploadAdapter;
function get_NullableStringAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return NullableStringAdapter;
}
var NullableStringAdapter;
var NullableDoubleAdapter;
function get_NullableIntAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return NullableIntAdapter;
}
var NullableIntAdapter;
function get_NullableBooleanAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return NullableBooleanAdapter;
}
var NullableBooleanAdapter;
var NullableAnyAdapter;
var NullableLongAdapter;
var ApolloOptionalStringAdapter;
var ApolloOptionalDoubleAdapter;
var ApolloOptionalIntAdapter;
var ApolloOptionalBooleanAdapter;
var ApolloOptionalAnyAdapter;
var NullableAdapterClass;
function NullableAdapter() {
  if (NullableAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.wrappedAdapter_1 = wrappedAdapter;
        var tmp = this.wrappedAdapter_1;
        // Inline function 'kotlin.check' call
        if (!!(tmp instanceof NullableAdapter())) {
          var message = 'The adapter is already nullable';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        var tmp;
        if (reader.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
          reader.skipValue_18u2ci_k$();
          tmp = null;
        } else {
          tmp = this.wrappedAdapter_1.fromJson_po5g3w_k$(reader, customScalarAdapters);
        }
        return tmp;
      }
      toJson_88jnsj_k$(writer, customScalarAdapters, value) {
        if (value == null) {
          writer.nullValue_h3u4a2_k$();
        } else {
          this.wrappedAdapter_1.toJson_h31rt1_k$(writer, customScalarAdapters, value);
        }
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_88jnsj_k$(writer, customScalarAdapters, value);
      }
    }
    initMetadataForClass($, 'NullableAdapter', VOID, VOID, [Adapter()]);
    NullableAdapterClass = $;
  }
  return NullableAdapterClass;
}
function nullable(_this__u8e3s4) {
  _init_properties_Adapters_kt__aoa3ac();
  return new (NullableAdapter())(_this__u8e3s4);
}
var ApolloOptionalAdapterClass;
function ApolloOptionalAdapter() {
  if (ApolloOptionalAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.wrappedAdapter_1 = wrappedAdapter;
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        var tmp;
        if (reader.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
          reader.skipValue_18u2ci_k$();
          tmp = Absent_getInstance();
        } else {
          tmp = new (Present())(this.wrappedAdapter_1.fromJson_po5g3w_k$(reader, customScalarAdapters));
        }
        return tmp;
      }
      toJson_4zp3w_k$(writer, customScalarAdapters, value) {
        if (value instanceof Present()) {
          this.wrappedAdapter_1.toJson_h31rt1_k$(writer, customScalarAdapters, value.value_1);
        } else {
          writer.nullValue_h3u4a2_k$();
        }
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_4zp3w_k$(writer, customScalarAdapters, value instanceof Optional() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ApolloOptionalAdapter', VOID, VOID, [Adapter()]);
    ApolloOptionalAdapterClass = $;
  }
  return ApolloOptionalAdapterClass;
}
var ObjectAdapterClass;
function ObjectAdapter() {
  if (ObjectAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter, buffered) {
        this.wrappedAdapter_1 = wrappedAdapter;
        this.buffered_1 = buffered;
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        var tmp;
        if (this.buffered_1) {
          tmp = Companion_instance.buffer_6f86a9_k$(reader);
        } else {
          tmp = reader;
        }
        var actualReader = tmp;
        actualReader.beginObject_5wddq0_k$();
        try {
          var result = this.wrappedAdapter_1.fromJson_po5g3w_k$(actualReader, customScalarAdapters);
          actualReader.endObject_ofuv3u_k$();
          return result;
        } catch ($p) {
          if ($p instanceof ApolloGraphQLException()) {
            var e = $p;
            while (actualReader.hasNext_bitz1p_k$()) {
              actualReader.nextName_njxula_k$();
              actualReader.skipValue_18u2ci_k$();
            }
            actualReader.endObject_ofuv3u_k$();
            throw e;
          } else {
            throw $p;
          }
        }
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        var tmp;
        if (this.buffered_1) {
          tmp = !(writer instanceof MapJsonWriter());
        } else {
          tmp = false;
        }
        if (tmp) {
          var mapWriter = new (MapJsonWriter())();
          mapWriter.beginObject_5wddq0_k$();
          this.wrappedAdapter_1.toJson_h31rt1_k$(mapWriter, customScalarAdapters, value);
          mapWriter.endObject_ofuv3u_k$();
          writeAny(writer, ensureNotNull(mapWriter.root_235k2_k$()));
        } else {
          writer.beginObject_5wddq0_k$();
          this.wrappedAdapter_1.toJson_h31rt1_k$(writer, customScalarAdapters, value);
          writer.endObject_ofuv3u_k$();
        }
      }
    }
    initMetadataForClass($, 'ObjectAdapter', VOID, VOID, [Adapter()]);
    ObjectAdapterClass = $;
  }
  return ObjectAdapterClass;
}
function obj(_this__u8e3s4, buffered) {
  buffered = buffered === VOID ? false : buffered;
  _init_properties_Adapters_kt__aoa3ac();
  return new (ObjectAdapter())(_this__u8e3s4, buffered);
}
var ListAdapterClass;
function ListAdapter() {
  if (ListAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.wrappedAdapter_1 = wrappedAdapter;
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        reader.beginArray_hxn19s_k$();
        // Inline function 'kotlin.collections.mutableListOf' call
        var list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        try {
          while (reader.hasNext_bitz1p_k$()) {
            list.add_utx5q5_k$(this.wrappedAdapter_1.fromJson_po5g3w_k$(reader, customScalarAdapters));
          }
          reader.endArray_s2tmpq_k$();
          return list;
        } catch ($p) {
          if ($p instanceof ApolloGraphQLException()) {
            var e = $p;
            while (reader.hasNext_bitz1p_k$()) {
              reader.skipValue_18u2ci_k$();
            }
            reader.endArray_s2tmpq_k$();
            throw e;
          } else {
            throw $p;
          }
        }
      }
      toJson_t3q33c_k$(writer, customScalarAdapters, value) {
        writer.beginArray_hxn19s_k$();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = value.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          this.wrappedAdapter_1.toJson_h31rt1_k$(writer, customScalarAdapters, element);
        }
        writer.endArray_s2tmpq_k$();
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_t3q33c_k$(writer, customScalarAdapters, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ListAdapter', VOID, VOID, [Adapter()]);
    ListAdapterClass = $;
  }
  return ListAdapterClass;
}
function list(_this__u8e3s4) {
  _init_properties_Adapters_kt__aoa3ac();
  return new (ListAdapter())(_this__u8e3s4);
}
var PresentAdapterClass;
function PresentAdapter() {
  if (PresentAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.wrappedAdapter_1 = wrappedAdapter;
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return new (Present())(this.wrappedAdapter_1.fromJson_po5g3w_k$(reader, customScalarAdapters));
      }
      toJson_fhp2jo_k$(writer, customScalarAdapters, value) {
        this.wrappedAdapter_1.toJson_h31rt1_k$(writer, customScalarAdapters, value.value_1);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_fhp2jo_k$(writer, customScalarAdapters, value instanceof Present() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'PresentAdapter', VOID, VOID, [Adapter()]);
    PresentAdapterClass = $;
  }
  return PresentAdapterClass;
}
function present(_this__u8e3s4) {
  _init_properties_Adapters_kt__aoa3ac();
  return new (PresentAdapter())(_this__u8e3s4);
}
var StringAdapter$1Class;
function StringAdapter$1() {
  if (StringAdapter$1Class === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return ensureNotNull(reader.nextString_kwkc9o_k$());
      }
      toJson_d6szpi_k$(writer, customScalarAdapters, value) {
        writer.value_hphtnt_k$(value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_d6szpi_k$(writer, customScalarAdapters, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    StringAdapter$1Class = $;
  }
  return StringAdapter$1Class;
}
var IntAdapter$1Class;
function IntAdapter$1() {
  if (IntAdapter$1Class === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return reader.nextInt_ujorgc_k$();
      }
      toJson_uci9wk_k$(writer, customScalarAdapters, value) {
        writer.value_2irneh_k$(value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_uci9wk_k$(writer, customScalarAdapters, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    IntAdapter$1Class = $;
  }
  return IntAdapter$1Class;
}
var DoubleAdapter$1Class;
function DoubleAdapter$1() {
  if (DoubleAdapter$1Class === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return reader.nextDouble_s2xvfg_k$();
      }
      toJson_4l6q4y_k$(writer, customScalarAdapters, value) {
        writer.value_pfghfv_k$(value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_4l6q4y_k$(writer, customScalarAdapters, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    DoubleAdapter$1Class = $;
  }
  return DoubleAdapter$1Class;
}
var FloatAdapter$1Class;
function FloatAdapter$1() {
  if (FloatAdapter$1Class === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return reader.nextDouble_s2xvfg_k$();
      }
      toJson_wyj8e4_k$(writer, customScalarAdapters, value) {
        writer.value_pfghfv_k$(value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_wyj8e4_k$(writer, customScalarAdapters, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    FloatAdapter$1Class = $;
  }
  return FloatAdapter$1Class;
}
var LongAdapter$1Class;
function LongAdapter$1() {
  if (LongAdapter$1Class === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return reader.nextLong_njwv0v_k$();
      }
      toJson_a965qo_k$(writer, customScalarAdapters, value) {
        writer.value_hdgek3_k$(value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_a965qo_k$(writer, customScalarAdapters, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    LongAdapter$1Class = $;
  }
  return LongAdapter$1Class;
}
var BooleanAdapter$1Class;
function BooleanAdapter$1() {
  if (BooleanAdapter$1Class === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return reader.nextBoolean_nfdk1h_k$();
      }
      toJson_z2pfjl_k$(writer, customScalarAdapters, value) {
        writer.value_z3qus4_k$(value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_z2pfjl_k$(writer, customScalarAdapters, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    BooleanAdapter$1Class = $;
  }
  return BooleanAdapter$1Class;
}
var AnyAdapter$1Class;
function AnyAdapter$1() {
  if (AnyAdapter$1Class === VOID) {
    class $ {
      fromJson_6z8oz1_k$(reader) {
        return ensureNotNull(readAny(reader));
      }
      toJson_3dj6of_k$(writer, value) {
        writeAny(writer, value);
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return this.fromJson_6z8oz1_k$(reader);
      }
      toJson_fbet6y_k$(writer, customScalarAdapters, value) {
        this.toJson_3dj6of_k$(writer, value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_fbet6y_k$(writer, customScalarAdapters, !(value == null) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    AnyAdapter$1Class = $;
  }
  return AnyAdapter$1Class;
}
var UploadAdapter$1Class;
function UploadAdapter$1() {
  if (UploadAdapter$1Class === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        // Inline function 'kotlin.error' call
        var message = 'File Upload used in output position';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      toJson_291k91_k$(writer, customScalarAdapters, value) {
        writer.value_bxcuou_k$(value);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_291k91_k$(writer, customScalarAdapters, (!(value == null) ? isInterface(value, Upload()) : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    UploadAdapter$1Class = $;
  }
  return UploadAdapter$1Class;
}
var properties_initialized_Adapters_kt_fd10e2;
function _init_properties_Adapters_kt__aoa3ac() {
  if (!properties_initialized_Adapters_kt_fd10e2) {
    properties_initialized_Adapters_kt_fd10e2 = true;
    StringAdapter = new (StringAdapter$1())();
    IntAdapter = new (IntAdapter$1())();
    DoubleAdapter = new (DoubleAdapter$1())();
    FloatAdapter = new (FloatAdapter$1())();
    LongAdapter = new (LongAdapter$1())();
    BooleanAdapter = new (BooleanAdapter$1())();
    AnyAdapter = new (AnyAdapter$1())();
    UploadAdapter = new (UploadAdapter$1())();
    NullableStringAdapter = nullable(get_StringAdapter());
    NullableDoubleAdapter = nullable(get_DoubleAdapter());
    NullableIntAdapter = nullable(get_IntAdapter());
    NullableBooleanAdapter = nullable(get_BooleanAdapter());
    NullableAnyAdapter = nullable(get_AnyAdapter());
    NullableLongAdapter = nullable(get_LongAdapter());
    ApolloOptionalStringAdapter = new (ApolloOptionalAdapter())(get_StringAdapter());
    ApolloOptionalDoubleAdapter = new (ApolloOptionalAdapter())(get_DoubleAdapter());
    ApolloOptionalIntAdapter = new (ApolloOptionalAdapter())(get_IntAdapter());
    ApolloOptionalBooleanAdapter = new (ApolloOptionalAdapter())(get_BooleanAdapter());
    ApolloOptionalAnyAdapter = new (ApolloOptionalAdapter())(get_AnyAdapter());
  }
}
//region block: exports
export {
  get_AnyAdapter as get_AnyAdapterx2g0krnqn0y9,
  get_BooleanAdapter as get_BooleanAdapterefxw889yjdy4,
  get_DoubleAdapter as get_DoubleAdapter3vjvxl0ttbawu,
  get_FloatAdapter as get_FloatAdapter8hkphxq3v57l,
  get_IntAdapter as get_IntAdapter2kzerdn7hhunh,
  get_LongAdapter as get_LongAdapter1acs38m0a7icu,
  get_NullableBooleanAdapter as get_NullableBooleanAdapter3vvq2rksy333a,
  get_NullableIntAdapter as get_NullableIntAdapter1poaa869odci7,
  get_NullableStringAdapter as get_NullableStringAdapter3fffxc67fmluc,
  get_StringAdapter as get_StringAdapter1plpsgiy8rwhj,
  get_UploadAdapter as get_UploadAdapter1jp2f4wtvjtde,
  list as list2lpjhmv1d2k19,
  nullable as nullable1in0t8o94jx9t,
  obj as obj2vqjd1bjrpmyg,
  present as presentmhd0a0ip21um,
};
//endregion

//# sourceMappingURL=Adapters.mjs.map
